import React from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Clock, Package, Home } from "lucide-react";
import { KD9LogoHorizontal, KD9Watermark } from "@/components/KD9Logo";
import ThemeToggle from "@/components/ThemeToggle";

const MESSAGES = {
  cliente: {
    color: "#16A34A",
    title: "¡Bienvenido a KD9!",
    sub: "Tu cuenta ha sido creada con éxito.",
    body: "Explora nuestros diagnósticos, agenda tu consulta y comienza tu proceso de transformación.",
    Icon: CheckCircle2,
    cta: "IR AL INICIO KD9",
    btnClass: "kd9-btn-gold",
    btnStyle: { background: "linear-gradient(180deg,#22c55e,#16A34A)", color: "#0a0a0a" },
  },
  consultor: {
    color: "#7C3AED",
    title: "Solicitud de consultor en revisión",
    sub: "Tu solicitud para ser consultor KD9 fue enviada.",
    body: "Mientras es revisada, puedes navegar como Usuario y acceder a todos los servicios disponibles. Te notificaremos por correo electrónico cuando tu cuenta sea aprobada.",
    Icon: Clock,
    cta: "ENTRAR COMO USUARIO",
    btnStyle: { background: "linear-gradient(180deg,#a855f7,#4B0082)", color: "#fff" },
  },
  creador: {
    color: "#D4AF37",
    title: "Solicitud de creador en revisión",
    sub: "Tu solicitud para ser creador KD9 fue enviada.",
    body: "Mientras es revisada, puedes navegar como Usuario y acceder a todos los servicios disponibles. Te notificaremos por correo electrónico cuando tu cuenta sea aprobada.",
    Icon: Package,
    cta: "ENTRAR COMO USUARIO",
    btnStyle: { background: "linear-gradient(180deg,#F0CB5A,#A67C00)", color: "#0a0a0a" },
  },
};

const PostRegister = () => {
  const { role = "cliente" } = useParams();
  const data = MESSAGES[role] || MESSAGES.cliente;

  return (
    <div className="relative min-h-screen flex flex-col" style={{ background: "var(--kd9-bg)" }} data-testid="post-register-page">
      <KD9Watermark size={680} opacity={0.04} className="absolute -right-40 top-20" />

      <header className="relative z-10 flex items-center justify-between p-6 lg:p-8">
        <Link to="/"><KD9LogoHorizontal size={36} /></Link>
        <ThemeToggle />
      </header>

      <main className="relative z-10 flex-1 flex items-center justify-center px-6 pb-20">
        <div
          className="kd9-card max-w-xl w-full p-10 lg:p-12 text-center kd9-fade-up kd9-glow"
          data-testid={`post-register-card-${role}`}
        >
          <div
            className="mx-auto w-20 h-20 rounded-full flex items-center justify-center mb-6"
            style={{
              background: `${data.color}22`,
              border: `1px solid ${data.color}66`,
              boxShadow: `0 0 30px ${data.color}55`,
            }}
          >
            <data.Icon size={36} style={{ color: data.color }} />
          </div>

          <div
            className="font-mont text-[11px] tracking-[0.4em] uppercase mb-3"
            style={{ color: data.color }}
          >
            {role}
          </div>

          <h1 className="font-cinzel kd9-gold-text text-3xl md:text-4xl tracking-[0.06em] mb-3">
            {data.title}
          </h1>
          <p
            className="font-cormorant text-xl mb-6"
            style={{ color: "var(--kd9-text)" }}
          >
            {data.sub}
          </p>
          <p
            className="font-mont text-sm leading-relaxed mb-10 max-w-md mx-auto"
            style={{ color: "var(--kd9-text-soft)" }}
          >
            {data.body}
          </p>

          <Link
            to="/app/inicio"
            className="inline-flex items-center justify-center gap-3 w-full py-4 rounded-xl text-[12px] font-mont font-semibold tracking-[0.16em] uppercase"
            style={data.btnStyle}
            data-testid="post-register-continue-btn"
          >
            <Home size={16} /> {data.cta}
          </Link>
        </div>
      </main>
    </div>
  );
};

export default PostRegister;
